import httpClient from '@/http-client'
import { baseMutations, baseState } from '@/store/mixins'

const BASE_URL = '/api/report/daily-closeout'

export default {
  namespaced: true,
  state: {
    ...baseState,
    summary: {
      total_amount: 0,
      total_discount: 0,
      grand_total: 0,
      deleted_invoices: { count: 0, total_amount: 0 },
      method_summary: { sum_in_dollar: 0, details: [], fx_rate_receip: 0 },
      fee_type_summary: [],
    }
  },
  mutations: {
    ...baseMutations,
    SET_SUMMARY(state, summary) {
      state.summary = summary
    }
  },
  actions: {
    async fetch(context, attrubutes = {}) {
      let params = Object.assign(
        {
          page: context.state.pagination.page,
          perPage: context.state.pagination.perPage,
        },
        attrubutes
      )
      let response = await httpClient.post(`${BASE_URL}`,
        params
      )
      context.commit('RECEIVE_RESOURCES', response.data)
      if (response.data.summary) {
        context.commit('SET_SUMMARY', response.data.summary)
      }
      return response
    },
    async pdf(context, attrubutes = {}) {
      let data = Object.assign(
        {
          page: context.state.pagination.page,
          perPage: context.state.pagination.perPage,
        },
        attrubutes
      )
      let response = await httpClient.post(`${BASE_URL}/pdf`,
        data
      )
      return response
    },
    async toExcel(context, attrubutes = {}) {
      let data = Object.assign(
        {
          page: context.state.pagination.page,
          perPage: context.state.pagination.perPage,
        },
        attrubutes
      )
      let response = await httpClient.post(`${BASE_URL}/excel`, data, {
        responseType: 'arraybuffer'
      })
      return response
    },
    async getBranch(context) {
      let response = await httpClient.get(`${BASE_URL}/assign-branch`)
      return response
    },
    async getSubProgram(context) {
      let response = await httpClient.get(`${BASE_URL}/sub-program`)
      return response
    },
    async getFeeTypes(context) {
      let response = await httpClient.get(`${BASE_URL}/fee-types`)
      return response
    },
  }
}
